import { render, staticRenderFns } from "./BlanketVOBDetails.vue?vue&type=template&id=058afc3a"
import script from "./BlanketVOBDetails.vue?vue&type=script&lang=js"
export * from "./BlanketVOBDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports